import React from 'react'
import { MessageCircle } from 'lucide-react'
import { ThreadPreview } from './ThreadPreview'
import { ThreadListSearch } from './ThreadListSearch'
import { ThreadListSkeleton } from '../Skeletons/ThreadListSkeleton'
// import { FilterTabs } from '../FilterTabs'
import type { ThreadListProps } from '../../types'

export const ThreadList: React.FC<ThreadListProps> = ({
  threads,
  selectedThreadId,
  onThreadSelect,
  // filter = 'all',
  // onFilterChange,
  loading = false,
  className = '',
  searchQuery = '',
  searchResultSnippets,
  searchResultMetadata,
  onSearchChange,
  onFiltersChange,
}) => {
  if (loading) {
    return <ThreadListSkeleton />
  }

  const renderContent = () => {
    if (threads.length === 0) {
      return (
        <div className="flex flex-col items-center justify-center text-center px-4 flex-1 h-full">
          <div className="h-64 flex flex-col items-center">
            <MessageCircle className="w-8 h-8 text-gray-400 dark:text-muted-foreground mb-4" />
            <h3 className="text-lg font-medium text-gray-900 dark:text-foreground mb-2">
              No conversations yet
            </h3>
            <p className="text-sm text-gray-500 dark:text-muted-foreground">
              Conversations will appear here when customers reach out
            </p>
          </div>
        </div>
      )
    }

    return (
      <div className="flex flex-col flex-1 pb-80">
        {threads.map(thread => {
          const metadata = searchResultMetadata?.get(thread.id)
          // Simply compare thread.id with selectedThreadId
          // For search results, thread.id is the composite ID (threadId-sessionId)
          // For normal threads, thread.id is the actual thread ID
          const isSelected = selectedThreadId === thread.id
          return (
            <ThreadPreview
              key={thread.id}
              thread={thread}
              isSelected={isSelected}
              onClick={() => onThreadSelect(thread.id)}
              searchQuery={searchQuery}
              searchSnippet={searchResultSnippets?.get(thread.id)}
              searchMetadata={metadata}
            />
          )
        })}
      </div>
    )
  }

  return (
    <div
      className={`w-80 md:w-64 lg:w-80 h-full flex flex-col box-border bg-gray-50 dark:bg-muted/30 border-r border-gray-200 dark:border-border overflow-hidden ${className}`}
    >
      {/* Search header */}
      {onSearchChange && (
        <ThreadListSearch
          searchQuery={searchQuery}
          onSearchChange={onSearchChange}
          onFiltersChange={onFiltersChange}
          loading={loading}
        />
      )}

      <div className="flex-1 overflow-y-auto overflow-x-hidden">
        {renderContent()}
      </div>
    </div>
  )
}
